import * as React from "react";
const SvgTriangleDown = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path d="M12 19 3 5h18Z" /></svg>;
export default SvgTriangleDown;